import Inbound from './inbound';

export const InboundConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth    : ['super', 'staff', 'inbound'],
    routes  : [
        {
            path     : '/inbound',
            component: Inbound
        }
    ]
};
